import { Role } from '@core/interfaces/user-role.interface';

export class SetUserRoles {
  public static readonly type = '[SetUserRoles] Set User Roles';

  constructor(public userRoles: Role[]) {}
}
